export default {
  items: {}
};
